export default {
  items: {}
};
